var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactusUploadDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.587 13.7319L14.3336 25.9852C12.8325 27.4864 10.7966 28.3297 8.67364 28.3297C6.55073 28.3297 4.51476 27.4864 3.01364 25.9852C1.51251 24.4841 0.669189 22.4482 0.669189 20.3252C0.669189 18.2023 1.51251 16.1664 3.01364 14.6652L15.267 2.4119C16.2677 1.41115 17.625 0.848938 19.0403 0.848938C20.4556 0.848938 21.8129 1.41115 22.8136 2.4119C23.8144 3.41265 24.3766 4.76996 24.3766 6.18524C24.3766 7.60051 23.8144 8.95782 22.8136 9.95857L10.547 22.2119C10.0466 22.7123 9.36794 22.9934 8.66031 22.9934C7.95267 22.9934 7.27401 22.7123 6.77364 22.2119C6.27326 21.7115 5.99216 21.0329 5.99216 20.3252C5.99216 19.6176 6.27326 18.9389 6.77364 18.4386L18.0936 7.1319",
    stroke: "#828282",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactusUploadDocumentIcon);
export default __webpack_public_path__ + "static/media/contactus_upload_document_icon.354636209d4b402a2247c63555c250ec.svg";
export { ForwardRef as ReactComponent };